/**
 * Formats a decimal value as a percentage string
 * Converts decimal to percentage (multiplies by 100) and removes trailing zeros
 *
 * @param value - The decimal value to format (e.g., 0.15 for 15%)
 * @returns Formatted percentage string without trailing zeros (e.g., "15" or "15.5")
 *
 * @example
 * formatPercentage(0.15) // "15"
 * formatPercentage(0.155) // "15.5"
 * formatPercentage(0.1500) // "15"
 * formatPercentage(null) // "0"
 * formatPercentage(undefined) // "0"
 */
export const formatPercentage = (value: number | null | undefined): string => {
  return ((value ?? 0) * 100).toFixed(2).replace(/[.,]00$/, '');
};
